import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { createCourse, ICourse } from '../../../models/courses';
import { IEntityToDisable } from '../../../models/entityToDisable';
import { AppDispatch, RootState } from '../../store';
import { setCourse, setCourses, startLoadingCourses, updateCourses } from './coursesSlice';

export const getCourses = (idParent?: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingCourses());

        let courses = {};
        if (idParent) {
            const resp = await fulfillmentApi.get(`coursesPerSubActivity/${idParent}`);
            courses = resp.data;
        }
        else {
            const resp = await fulfillmentApi.get(`courses`);
            courses = resp.data;
        }

        dispatch(setCourses({ courses }));
    }
}

export const getCourse = (courseId: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingCourses());
        const resp = await fulfillmentApi.get(`courses/${courseId}`);

        dispatch(setCourse({ course: resp.data }));
    }
}

export const saveCourse = (course: ICourse) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingCourses());
        const newCourse = createCourse(course);
        const resp = await fulfillmentApi.post(`courses`, newCourse);

        const state = getState();
        let courses = [...state.courses.courses];
        courses.push(resp.data);

        dispatch(setCourses({ courses }));
    }
}

export const editCourse = (course: ICourse) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingCourses());
        await fulfillmentApi.put(`courses/${course.id}`, course);

        const resp = await fulfillmentApi.get(`courses/${course.id}`);

        dispatch(setCourse({ course: resp.data }));
        dispatch(updateCourses({ course: resp.data }));
    }
}

export const disableCourse = (entityToDisable: IEntityToDisable) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingCourses());

        await fulfillmentApi.put(`courses/expire/${entityToDisable.id}`, entityToDisable);

        const resp = await fulfillmentApi.get(`courses/${entityToDisable.id}`);

        dispatch(setCourse({ course: resp.data }));
        dispatch(updateCourses({ course: resp.data }));
    }
}

export const addCourse = (courseId: number, idParent: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingCourses());

        let courses = {};

        await fulfillmentApi.post(`coursesPerSubActivity/${idParent}?courseId=${courseId}`);
        let r = await fulfillmentApi.get(`coursesPerSubActivity/${idParent}`);
        courses = r.data;

        dispatch(setCourses({ courses }));
    }
}

export const removeCourse = (courseId: number, idParent: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingCourses());

        let courses = {};

        await fulfillmentApi.delete(`coursesPerSubActivity/${idParent}?courseId=${courseId}`);
        let r = await fulfillmentApi.get(`coursesPerSubActivity/${idParent}`);
        courses = r.data;

        dispatch(setCourses({ courses }));
    }
}